export enum Quarter {
    UNKNOWN = 0,
    FIRST = 1,
    SECOND = 2,
    THIRD = 3,
    FOURTH = 4
}
